import { useDispatch } from 'react-redux'

import type { AppDispatch } from '../state/store'

const useAppDispatch = () => useDispatch<AppDispatch>()

export default useAppDispatch
